module.exports = __webpack_public_path__ + "static/media/logo.37b6cb33.png";